export default "__VITE_ASSET__d2711bf9__"